import { createRouter, createWebHistory } from "vue-router";

const routes = [{
	path: "/",
	redirect: "/about",
	component: () => import("../App.vue"),
	children: [{
			path: "about",
			name: "About",
			title: "关于我们",
			component: () => import("@/views/about/index"),
		},
		{
			path: "course",
			name: "Course",
			title: "AI课程",
			component: () => import("@/views/course/index"),
		},
		{
			path: "course_detail",
			name: "Course_Detail",
			title: "AI课程",
			component: () => import("@/views/course/detail"),
		},
		{
			path: "enterprise_training",
			name: "EnterpriseTraining",
			title: "企培专区",
			component: () => import("@/views/enterprise_training/index"),
		},
		{
			path: "tool",
			name: "Tool",
			title: "AI工具",
			component: () => import("@/views/tool/index"),
		},
		{
			path: "tool_detail",
			name: "Tool_Detail",
			title: "AI工具",
			component: () => import("@/views/tool/detail"),
		},
		{
			path: "timetable",
			name: "Timetable",
			title: "开课时间表",
			component: () => import("@/views/timetable/index"),
		},
		{
			path: "bi",
			name: "biData",
			title: "BI数据报表",
			component: () => import("@/views/bi/data"),
		},
		{
			path: "code",
			name: "codeIndex",
			title: "二维码",
			component: () => import("@/views/code/index"),
		}
	],
}, ];
// const routerHistory = createWebHistory();
const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});
export default router;